module.exports = __webpack_public_path__ + "assets/img/stempelstellen-bg.d8f283db.jpg";